import React from "react";
import RadioWrapper from "./style";

const CustomRadio = (props) => <RadioWrapper {...props} />;

export default CustomRadio;
